var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 2.29473C6.19233 2.29473 2.29485 6.19221 2.29485 11C2.29485 15.8078 6.19233 19.7053 11.0001 19.7053C15.8079 19.7053 19.7054 15.8078 19.7054 11C19.7054 6.19221 15.8079 2.29473 11.0001 2.29473ZM1.37207 11C1.37207 5.68258 5.6827 1.37195 11.0001 1.37195C16.3176 1.37195 20.6282 5.68258 20.6282 11C20.6282 16.3174 16.3176 20.6281 11.0001 20.6281C5.6827 20.6281 1.37207 16.3174 1.37207 11Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6499 15.4H10.3444V9.56884H11.6499V15.4ZM10.2666 8.02405C10.2666 7.80261 10.3296 7.63214 10.4555 7.51263C10.5851 7.39313 10.7685 7.33337 11.0055 7.33337C11.2351 7.33337 11.4129 7.39313 11.5388 7.51263C11.6685 7.63214 11.7333 7.80261 11.7333 8.02405C11.7333 8.23494 11.6685 8.4019 11.5388 8.52492C11.4129 8.64443 11.2351 8.70418 11.0055 8.70418C10.7685 8.70418 10.5851 8.64443 10.4555 8.52492C10.3296 8.4019 10.2666 8.23494 10.2666 8.02405Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/information.783a197b95a78d6da6ea16ec76c01c78.svg";